<template>
  <div class="banner-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="product-info">
          产品名称
          <div class="name">{{productName}}</div>
        </div>
        <div class="table-box">
          <div style="margin-right: 10px;">
            <el-table
              :data="clickList"
              class="order-table table no-border-table"
              ref="orderTable"
              :header-cell-style="{
                border: 'none',
                color: '#333',
                background: '#f6f6f6',
                borderBottom: '1px solid #E8E8E8',
                height: '54px',
              }"
              :row-style="{
                height: '54px',
              }"
            >
              <el-table-column
                type="index"
                align="center"
                label="序号"
              ></el-table-column>
              <el-table-column
                prop="userName"
                align="center"
                label="点击该产品的用户"
              ></el-table-column>
              <el-table-column label="操作" align="center" width="180">
                <div
                  slot-scope="scope"
                  style="display: flex;justify-content: center;"
                >
                  <div>
                    <button
                      size="mini"
                      class="table-btn"
                      @click="toDetail(scope.row)"
                    >
                      查看用户详情
                    </button>
                  </div>
                </div>
              </el-table-column>
            </el-table>
            <!-- 分页按钮 -->
            <div class="footer">
              <el-pagination
                @current-change="handleCurrentChangeClick"
                :current-page.sync="currentPageClick"
                background
                layout="total, prev, pager, next, jumper"
                :page-size="size"
                :total="totalClick"
              ></el-pagination>
            </div>
          </div>
          <div>
            <el-table
              :data="consultList"
              class="order-table table no-border-table"
              ref="orderTable"
              :header-cell-style="{
                border: 'none',
                color: '#333',
                background: '#f6f6f6',
                borderBottom: '1px solid #E8E8E8',
                height: '54px',
              }"
              :row-style="{
                height: '54px',
              }"
            >
              <el-table-column
                type="index"
                align="center"
                label="序号"
              ></el-table-column>
              <el-table-column
                prop="userName"
                align="center"
                label="咨询该产品的用户"
              ></el-table-column>
              <el-table-column label="操作" align="center" width="180">
                <div
                  slot-scope="scope"
                  style="display: flex;justify-content: center;"
                >
                  <div>
                    <button
                      size="mini"
                      class="table-btn"
                      @click="toDetail(scope.row)"
                    >
                      查看用户详情
                    </button>
                  </div>
                </div>
              </el-table-column>
            </el-table>
            <!-- 分页按钮 -->
            <div class="footer">
              <el-pagination
                @current-change="handleCurrentChangeConsult"
                :current-page.sync="currentPageConsult"
                background
                layout="total, prev, pager, next, jumper"
                :page-size="size"
                :total="totalConsult"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
export default {
  components: {
    Header
  },
  name: 'banner',
  data() {
    return {
      loading: 0, // 加载中
      currentPageClick: 1, // 当前页码
      size: 20, // 每页条数
      totalClick: 0, // 总页数
      currentPageConsult: 1, // 当前页码
      totalConsult: 0, // 总条数
      title: {
        // 页面标题
        firstTitile: '商城设置',
        secondTitle: '产品点击和咨询'
      },
      filter: {
        uid: null
      },
      clickList: [], // 轮播列表
      consultList: []
    };
  },
  mounted() {
    // 获取列表
    this.productName = this.$route.query.productName;
    this.getIndexProductClick();
    this.getIndexProductConsult();
  },
  computed: {},
  methods: {
    // 表格序号
    tableIndex(index) {
      return ++index;
    },
    // 切换页码
    handleCurrentChangeClick(page) {
      this.currentPage = page;
      this.getIndexProductClick();
    },
    handleCurrentChangeConsult(page) {
      this.currentPage = page;
      this.getIndexProductConsult();
    },
    // 获取轮播列表
    getIndexProductClick() {
      this.loading++;
      this.httpGet(this.$root.getIndexProductClick, {
        page: this.currentPage,
        size: this.size,
        productName: this.productName
      }).then(
        (res) => {
          this.loading--;
          this.clickList = res.list;
          this.totalClick = res.total;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 获取轮播列表
    getIndexProductConsult() {
      this.loading++;
      this.httpGet(this.$root.getIndexProductConsult, {
        page: this.currentPage,
        size: this.size,
        productName: this.productName
      }).then(
        (res) => {
          this.loading--;
          this.consultList = res.list;
          this.totalConsult = res.total;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    toDetail(row){
        this.$router.push({
        name: 'userDetail',
        query: {
          uid: row.uid
        }
      });
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.banner-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 0 20px 20px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
    //   background: white;
      box-sizing: border-box;
    //   padding: 24px 32px;
      border-radius: 2px;
      flex-y(flex-start, flex-start);

      .product-info{
        width: 100%;
        height: 88px;
        background: #fff;
        flex-y(center, flex-start);
        padding-left: 24px;
        word(14px, #666);
        border-radius: 10x;
        .name{
            word(32px, #333);
            margin-top: 6px;
        }
      }

      .table-box{
        width: 100%;
        margin-top: 10px;
        flex-x(flex-start, flex-start);
        flex: 1;
        >div{
            flex: 1;
            height: 100%;
            flex-y(flex-start, flex-start);
            background: #fff;
            padding: 20px;
            box-sizing: border-box;
        }
      }

      // 按钮
      .btn {
        // width: 100px;
        display: inline-block;
        padding: 0 30px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin-bottom: 16px;
        // margin: 16px 0;
      }

      .tip {
        margin-left: 32px;
        color: #40B98F;
      }

      // 表格按钮
      .table-btn {
        width: 100px;
        height: 24px;
        line-height: 24px;
        color: gray3;
        font-size: 12px;
        margin-right: 8px;
        cancel-btn();
      }

      .table-img {
        height: 70px;
        width: auto;
      }
    }
  }
}
</style>
